import script from "./ViewSupervisorsGroupTalks.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewSupervisorsGroupTalks.vue?vue&type=script&setup=true&lang=js"

import "./ViewSupervisorsGroupTalks.vue?vue&type=style&index=0&id=8ba64ef6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ba64ef6"]])

export default __exports__